import { render, staticRenderFns } from "./cash_detail.vue?vue&type=template&id=08127a94&scoped=true&"
import script from "./cash_detail.vue?vue&type=script&lang=js&"
export * from "./cash_detail.vue?vue&type=script&lang=js&"
import style0 from "./cash_detail.vue?vue&type=style&index=0&id=08127a94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08127a94",
  null
  
)

export default component.exports